// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3CMIr","Menu":"Layout_Menu__3j1wH","Content":"Layout_Content__37oK7"};